// extracted by mini-css-extract-plugin
export var commentContainer = "mobileComment-module--commentContainer--e29op";
export var taskContainer = "mobileComment-module--taskContainer--N42EO";
export var task0 = "mobileComment-module--task0--Bw8iH";
export var taskEdit = "mobileComment-module--taskEdit--CYCLG";
export var taskActivity = "mobileComment-module--taskActivity--f9TWG";
export var textContainer = "mobileComment-module--textContainer--xx7QG";